/**
 * One view of a skill map, plugged into SkillMapViewModes. value names it in the view's
 * skillMapView search param and label is its toggle button's text; the children are shown
 * when it is chosen.
 *
 * @param {{ value: string, label: string, children: import("react").ReactNode }} props
 */
export function SkillMapViewMode({ children }) {
    return children
}
